import { Bot, Eye, Zap, Shield } from 'lucide-react';
import { Tooltip } from '../ui/Tooltip';

export type AutonomyLevel = 0 | 1 | 2 | 3;

export interface AutonomyIndicatorProps {
  level: AutonomyLevel;
  action?: string; // e.g., "Auto-classified", "Suggested response"
  compact?: boolean;
}

const config = {
  0: { label: 'Manual', icon: Shield, color: 'text-surface-400', bg: 'bg-surface-600/20', description: 'Performed manually' },
  1: { label: 'AI Suggested', icon: Eye, color: 'text-blue-400', bg: 'bg-blue-500/10', description: 'AI suggested this action' },
  2: { label: 'AI Executed', icon: Bot, color: 'text-amber-400', bg: 'bg-amber-500/10', description: 'AI executed, review recommended' },
  3: { label: 'AI Handled', icon: Zap, color: 'text-emerald-400', bg: 'bg-emerald-500/10', description: 'Fully automated by AI' },
} as const;

export function AutonomyIndicator({ level, action, compact = false }: AutonomyIndicatorProps) {
  if (level === 0) return null; // Don't show indicator for manual actions

  const { label, icon: Icon, color, bg, description } = config[level];
  const tooltipText = action ? `${label}: ${action}` : description;

  return (
    <Tooltip content={tooltipText} side="top">
      <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${color} ${bg}`}>
        <Icon className="h-3 w-3" />
        {!compact && <span>{label}</span>}
      </span>
    </Tooltip>
  );
}
